module.exports = __webpack_public_path__ + "img/head_bg-app-old.74829d6b.png";